import type { FunctionComponent } from "react";
import { NewCommunicationSliderAdminPartial } from "../../../../partials/admin/menus/communication/new-communication-slider.admin.partials";

export const NewCommunicationSliderMenuAdminScreen: FunctionComponent = () => {
	return <NewCommunicationSliderAdminPartial />;
};
